// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__TsNfj","container":"Breadcrumbs_container__UE6tY","arrowBack":"Breadcrumbs_arrowBack__HQvEv"};